import $ from "jquery";
window.$ = window.jquery = $;

import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import Base from '../utils/base'

import Header from './components/Header'
import Facility from './components/Facility'

export default function FacilityIndex(props) {
	var base = new Base()

  return (
    <>
      <Header/>
      <Facility/>
    </>
  );
};
